<common-navigation [disabledLink]="disabledLink"></common-navigation>
<div class="container-fluid">
    <div class="row no-gutter">
        <div class="col-md-12 col-lg-4">
            <div class="default-box long-form d-flex">
                <div class="container">
                    <div class="row pmethod-side-nav">
                        <div class="col-md-12" id="side-nav">
                          <p class="alert alert-danger alert-warning" *ngIf="voucherError">{{ voucherErrorMessage }}</p>
<!--                          <p class="alert alert-info alert-warning" *ngIf="!voucherError">If you have been provided with a voucher code please enter it on the voucher input below.</p>-->
                            <div id="page-redirection" *ngIf="!hideRedirect && showDeviceDelivery">
                              <a (click)="redirectToDeliveryAddress()" >
                                  <img src="../../../../assets/images/arrows/back_arrow.png">
                                  Back to address
                              </a>
                            </div>
                          <h3 class="display-4 box-title">Payment Methods</h3> <br>
                          <div class="alert alert-danger alert-dismissible fade show mt-2" role="success" *ngIf="paymentError">
                            <button type="button" class="close" data-dismiss="alert">&times;</button>
                            Error on payment
                          </div>
<!--                          <form method="post" id="payment-voucher-form" (ngSubmit)="onSubmit()">-->
                            <div class="form-row-card">
                              <div id="card-element"></div>
                              <div id="card-errors" role="alert"></div>
                            </div><br>
                            <div class="payment-summary mb-2">
                              <h6 class="font-weight-bold">Take a Breath Subscription <span *ngIf="showDeviceDelivery">+ Breathing Device</span></h6>
                              <p>NZD ${{ plan_price }} per/year</p>
                              <h6 class="font-weight-bold" *ngIf="showDeviceDelivery">Delivery Fee</h6>
                              <p *ngIf="showDeviceDelivery">NZD ${{ delivery_charge }} ({{ delivery_country }})</p>
                            </div>
                            <h3 class="text-center my-5" style="font-weight: 800;">OR</h3>
                            <div class="payment-summary">
                              <h3 class="display-4 box-title">Voucher Code</h3>
                              <p class="mt-3">If you have been provided with a voucher code please enter it on the voucher input below.</p>
                              <div class="md-input mt-0">
                                <input
                                    id="voucherCode"
                                    [(ngModel)]="voucherCode"
                                    maxlength="10"
                                    class="md-form-control"
                                    type="text"
                                    oninput="this.value = this.value.toUpperCase()"
                                ></div>
                            </div><br>
                            <button class="btn btn-primary btn-block btn-submit" [disabled]="disableBtn" (click)="onSubmit()">
                              Continue
                              <img src="../../../../assets/images/loader.gif" *ngIf="loading">
                            </button>
<!--                          </form>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-8 d-none d-lg-flex default-box bg-image"></div>
    </div>
</div>
